import pc from "picocolors";

export function renderBanner(version?: string): string {
  const lines = [
    "  ____  ____   _______  __",
    " / __ \\/ __ \\ / ____/ |/ /",
    "/ / / / /_/ // / __ |   / ",
    "/ /_/ / _, _// /_/ //   | ",
    "\\____/_/ |_| \\____//_/|_| ",
  ];

  const art = lines.map((line) => pc.cyan(line)).join("\n");
  const tag = version ? `  ${pc.dim(`v${version}`)}` : "";
  return `${art}${tag}`;
}

